import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'
import { HISTORY, SNAPSHOTS_URI } from 'constants/featureSnapshots'

import { Icon } from 'components/patterns'

import { FeatureHistoryCardContent } from '..'

import {
  HistoryListHeader,
  HistoryList,
  HistoryDivider,
  NoHistoryFound,
  DrawerWrapper,
} from './FeatureHistoryListNavPane.style'

/* eslint-disable react-hooks/exhaustive-deps */
const FeatureHistoryListNavPane = ({
  snapshotUri,
  snapshots,
  setFeatureSnapshot,
  setUriQueryString,
  location,
}) => {
  const handleSnapshotSelect = (id) => {
    setUriQueryString({ search: `?${HISTORY}=${id}` })
    setFeatureSnapshot(`${SNAPSHOTS_URI}/${id}`)
  }

  const getCardData = useCallback(
    (snapshot, disableClick = false) => {
      const { uri, id, date, user } = snapshot

      const selected = uri === snapshotUri

      return {
        key: uri,
        content: (
          <FeatureHistoryCardContent
            uri={uri}
            date={date}
            user={user}
            selected={selected}
            location={location}
          />
        ),
        onClick: () => handleSnapshotSelect(id),
        selected,
        onClickDisabled: disableClick,
      }
    },
    [snapshotUri]
  )

  const cardListData = useMemo(
    () => snapshots.map((snapshot) => getCardData(snapshot)),
    [snapshots, getCardData]
  )

  const hasNoSnapshot = snapshots.length === 0

  return (
    <DrawerWrapper>
      <HistoryListHeader type="h3">
        <Icon icon="history" />
        {strings.history}
      </HistoryListHeader>

      <HistoryDivider />

      {hasNoSnapshot ? (
        <NoHistoryFound size="small">{strings.no_history}</NoHistoryFound>
      ) : (
        <HistoryList cards={cardListData} />
      )}
    </DrawerWrapper>
  )
}

FeatureHistoryListNavPane.propTypes = {
  snapshotUri: PropTypes.string,
  snapshots: PropTypes.array,
  setUriQueryString: PropTypes.func,
  setFeatureSnapshot: PropTypes.func,
  children: PropTypes.element,
  location: PropTypes.object,
}

export default FeatureHistoryListNavPane
